export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8963.b3b6598b.jpg";